import React, { ReactNode } from 'react';
import Text, { TextProps } from '../Text';

interface Props {
  title: string;
  children?: ReactNode;
  variant?: TextProps['variant'];
}

export default function StateHeading({ title, children, variant = 'muted' }: Props) {
  return (
    <div className="space-y-4">
      <Text
        as="div"
        variant="base"
        className="text-2xl font-medium"
        role="heading"
        aria-level={2}
        aria-live="polite"
      >
        {title}
      </Text>
      {children && (
        <Text as="p" variant={variant} className="leading-6">
          {children}
        </Text>
      )}
    </div>
  );
}
